import { render, staticRenderFns } from "./project-detail.vue?vue&type=template&id=f06953aa&"
import script from "./project-detail.vue?vue&type=script&lang=js&"
export * from "./project-detail.vue?vue&type=script&lang=js&"
import style0 from "./project-detail.vue?vue&type=style&index=0&id=f06953aa&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports